import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { FeldServiceModule } from '..';
import { SavedFeldFiltersComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    FeldServiceModule
  ],
  declarations: [SavedFeldFiltersComponent],
  exports: [SavedFeldFiltersComponent],

})
export class SavedFeldFiltersComponentModule { }
